import { screenSizeDetection as r } from "@sunrise/shared";
import { defineComponent as s, ref as p } from "vue";
import i from "./index7.js";
import m from "./index22.js";
import a from "./index170.js";
import d from "./index192.js";
const L = s({
  name: "MsFooterSEOLinkList",
  components: {
    MsText: d,
    MsHeadline: a,
    CsAccordion: i,
    CsExpander: m
  },
  props: {
    cmsContent: {
      type: Object,
      required: !0
    },
    headline: Object,
    linkLists: Object,
    showMoreButton: Boolean
  },
  emits: ["update:expanded"],
  setup(c, { emit: o }) {
    const { isScreenL: t } = r(), e = p(!1);
    function n() {
      o("update:expanded", e.value = !e.value);
    }
    return {
      isScreenL: t,
      expanded: e,
      onModelUpdate: n
    };
  }
});
export {
  L as default
};
